import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsFilterApplied } from "@/utilities/utils";

import {
  fetchUpcomingCandidateDashbord,
  setDashboardUpcomingListLoading,
  updateDashboardUpcomingFilters,
  updateDashboardUpcomingPagination,
} from "../../../../reducers/clientdashboard";
import TableSearch from "../dataTables/TableSearch";
/**
 * SearchFilter component for filtering and searching candidates.
 *
 * @return {JSX.Element} The search filter component.
 */
export const SearchFilter = () => {
  const {
    UpComingfilters,
    upComingPagination,
    isDashboardUpcomingListLoading,
  } = useSelector((state) => state.clientDashboard);
  const filterApplied = getIsFilterApplied(UpComingfilters);
  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   */
  const handleSearch = (e) => {
    dispatch(updateDashboardUpcomingFilters({ search: e.target.value }));
  };

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setDashboardUpcomingListLoading(true));
      dispatch(
        updateDashboardUpcomingPagination({
          ...upComingPagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      // dispatch(deSelectAllCandidate())
      dispatch(fetchUpcomingCandidateDashbord(UpComingfilters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [UpComingfilters.search]);

  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={UpComingfilters.search} handleChange={handleSearch} />
        {/* <FilterButton
                    filterApplied={filterApplied}
                    handleClick={() => {
                        dispatch(showFilterModal(true));
                    }}
                /> */}
      </div>
    </div>
  );
};
